import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getAllRoles,
  getStaffById,
  PostAddStaff,
  PostUpdateStaff,
} from "../../hooks/services/api-services";
import {
  decryptAEStoJSON,
  toastEmitter,
  validateRegex,
} from "../../utils/utilities";
import { API_RESPONSE } from "../../utils/app-constants";
import { ROUTES } from "../../hooks/routes/routes-constant";
import {
  alphanumericHypenRegex,
  EmailRegex,
  NoLeadingSpaceRegex,
  PasswordRegex,
} from "../../utils/regexValidation";
import BreadCrum from "../../components/common/BreadCrum";
import Input from "../../components/common/input";
import DropDown from "../../components/common/dropdown";
import { handleFormInput } from "../../utils/form-utils";
import Button from "../../components/common/button";
import { EYE_CLOSE, EYE_OPEN } from "../../utils/aap-image-constant";
import PhoneInput from "react-phone-input-2";
import { useTranslation } from "react-i18next";

const Addstaff = () => {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);
  const navigate = useNavigate();
  const [rolelist, setRoleList] = useState([]);
  const [isPwdVisible, setIsPwdVisible] = useState("password");
  const [payload, setPayload] = useState({
    id: 0,
    userName: "",
    email: "",
    roleId: 0,
    clinicId: userData?.id || 0,
    doctorId: 0,
    password: "",
    mobileNo: "",
    profile: "",
    languageType: i18n.language,
  });

  const location = useLocation();
  const activeTab = location?.state?.activeTab || "staff";
  const checkfromType = location?.state?.formType;
  const staffId = location?.state?.staffId;
  const fetchRoleMaster = async () => {
    const payload = {
      pageIndex: null,
      pageSize: null,
      searchText: "",
      status: 1,
      direction: "desc",
      filterByFieldName: "",
      clinicId: userData?.id,
      doctorId: 0,
      languageType: i18n.language,
    };
    try {
      const response = await getAllRoles(payload);

      if (response.status !== 200) {
        toastEmitter("error", response?.data?.message);
      } else {
        const formattedList = response?.data?.data?.roleList?.map((role) => ({
          label: role.roleName,
          value: role.id,
        }));
        setRoleList(formattedList);
      }
    } catch (err) { }
  };

  const fetchStaffById = async (staffId) => {
    try {
      const response = await getStaffById(staffId, i18n.language);
      if (response.status !== 200) {
        toastEmitter("error", response?.data?.message);
      } else {
        let rowData = response?.data?.data;
        setPayload({
          id: rowData?.id,
          userName: rowData?.userName || "",
          email: rowData?.email || "",
          roleId: Number(rowData?.roleResponsePayload?.id),
          clinicId: rowData?.clinicId,
          password: rowData?.password || "",
          mobileNo: rowData?.mobileNo || "",
          profile: "",
          languageType: i18n.language
        });
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    }
  };
  useEffect(() => {
    if (staffId) {
      fetchStaffById(staffId);
    }
  }, [staffId, i18n.language]);
  useEffect(() => {
    fetchRoleMaster();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !NoLeadingSpaceRegex.test(payload?.userName) ||
      payload?.userName.trim() === "" ||
      !alphanumericHypenRegex.test(payload?.userName)
    ) {
      return toastEmitter(
        "error",
        "Please enter a valid Staff Name (No leading spaces, cannot be empty, only alphanumeric & hyphen allowed)."
      );
    }

    if (
      !NoLeadingSpaceRegex.test(payload?.email) || // Prevents leading spaces
      payload?.email.trim() === "" || // Prevents empty values
      !validateRegex(payload.email, EmailRegex) // Ensures only alphanumeric + hyphen
    ) {
      return toastEmitter(
        "error",
        "Please enter a valid Email (No leading spaces, cannot be empty)."
      );
    }
    if (payload.roleId === 0) {
  if (!payload.roleId || Number(payload.roleId) === 0) {
  return toastEmitter("error", "Please select role");
}
    }
    if (checkfromType === "add") {
      if (payload.password.trim() === "") {
        return toastEmitter("error", "Password is mandatory!");
      }
      if (!validateRegex(payload.password, PasswordRegex)) {
        return toastEmitter(
          "error",
          "Password should be a combination  8  characters which include altleast one special character , special symbol , capital letter and number"
        );
      }
    }

    setIsLoading(true);

    if (checkfromType === "add") {
      PostAddStaff(payload)
        .then(function (response) {
          if (response.data?.status !== 200) {
            toastEmitter("error", response?.data?.message);
          } else {
            toastEmitter("success", "Staff added successfully!");
            navigate(ROUTES.ROLE_MANAGEMENT, {
              state: { activeTab: "staff" },
            });
          }
          return setIsLoading(false);
        })
        .catch(function (err) {
          return setIsLoading(false);
        });
    } else {
      PostUpdateStaff(payload)
        .then(function (response) {
          if (response?.data?.status !== 200) {
            toastEmitter("error", response?.data?.message);
          } else {
            toastEmitter("success", "Staff updated successfully!");
            navigate(ROUTES.ROLE_MANAGEMENT, {
              state: { activeTab: "staff" },
            });
          }
          return setIsLoading(false);
        })
        .catch(function (err) {
          return setIsLoading(false);
        });
    }
  };
  const handleSelectRole = (e) => {
    setPayload({ ...payload, roleId: e.target.value });
  };

  const handleDataBack = () => {
    setPayload({
      id: 0,
      userName: "",
      email: "",
      roleId: 0,
      clinicId: 0,
      password: "",
      mobileNo: "",
      profile: "",
      languageType: i18n.language
    });
    navigate(ROUTES.ROLE_MANAGEMENT, {
      state: { activeTab },
    });
  };
  const dialCodeToISO = {
    49: "de",
    33: "fr",
    966: "sa",
    971: "ae",
  };

  const cleanedDialCode = userData?.code?.replace(/\D/g, ""); // handles "+++++33" -> "33"
  const selectedCountryISO = dialCodeToISO[cleanedDialCode] || "ae";

  const handleNumber = (value, countryData) => {
    const dialCode = countryData?.dialCode || "";

    // Remove all non-digit characters
    let cleanedValue = value.replace(/\D/g, "");

    // Remove the dial code from the start
    if (cleanedValue.startsWith(dialCode)) {
      cleanedValue = cleanedValue.slice(dialCode.length);
    }

    setPayload((prev) => ({
      ...prev,
      mobileNo: `+${dialCode} ${cleanedValue}`,
    }));
  };
  const pageAction =
    checkfromType === "add"
      ? t("Add")
      : checkfromType === "edit"
        ? t("Edit")
        : t("View");
  return (
    <div className="main_datatable my-lg-3 mt-1 ">
      <form onSubmit={handleSubmit}>
        <div className=" add_doctor card p-3 border border-radius_input mb-3">
          <BreadCrum
            firstData={t("Role Management")}
            iconshow1={true}
            secondData={`${pageAction} ${t("Staff")}`}
            onFirstDataClick={handleDataBack}
          />
          <div className="row">
            <div className="col-md-6 mb-2">
              <Input
                className="border-radius_input"
                type="text"
                value={payload.userName}
                disabled={checkfromType === "view"}
                name="userName"
                placeHolder="Enter staff"
                handleChange={(e) => setPayload(handleFormInput(e, payload))}
                labelName="Staff Name"
              />
            </div>

            <div className="col-12 col-md-6">
              <label htmlFor="username">
                {t("Mobile Number")} <span className=" text-danger">*</span>
              </label>
              <div
                className={`${i18n.language === "ar" ? "arabicnumber" : "numberinput"
                  }`}
              >
                <PhoneInput
                  country={selectedCountryISO}
                  value={payload.mobileNo}
                  countryCodeEditable={false}
                  onlyCountries={[selectedCountryISO]}
                  onChange={(value, country) => handleNumber(value, country)}
                  enableSearch={false}
                  disabled={checkfromType === "view"}
                  disableDropdown={true}
                  inputProps={{
                    name: "mobileNo",
                    className: "form-control w-100 border-radius_input",
                  }}
                />
              </div>
            </div>

            <div className="col-md-6 mb-2">
              <Input
                className="border-radius_input"
                type="email"
                value={payload.email}
                disabled={checkfromType === "view"}
                name="email"
                placeHolder="Enter email"
                handleChange={(e) => setPayload(handleFormInput(e, payload))}
                labelName="Staff Email"
              />
            </div>
            <div className="col-md-6 mb-2">
              <DropDown
                labelName="Select Role"
                name="roleId"
                options={rolelist}
                value={payload.roleId}
                handleSelect={handleSelectRole}
                showastrict={true}
                className="border-radius_input"
                disabled={checkfromType === "view"}
              />
            </div>
            {checkfromType === "add" && (
              <div className="col-md-6 mb-2">
                <Input
                  className="border-radius_input"
                  type={isPwdVisible}
                  value={payload.password}
                  name="password"
                  placeHolder="Enter your password"
                  handleChange={(e) => setPayload(handleFormInput(e, payload))}
                  labelName="Password"
                  showRightIcon={true}
                  disabled={checkfromType === "view"}
                  rightIconSrc={
                    isPwdVisible === "password" ? EYE_CLOSE : EYE_OPEN
                  }
                  onRightIconClick={() =>
                    setIsPwdVisible(
                      isPwdVisible === "password" ? "text" : "password"
                    )
                  }
                />
              </div>
            )}
          </div>
        </div>

        <div className="d-flex flex-wrap  justify-content-center ">
          <Button
            type="button"
            className={`px-5 py-2 rounded border-0  cancelbtn mb-2 ${i18n.language === "ar" ? "ms-2" : "me-2"
              }`}
            label="Cancel"
            onClick={handleDataBack}
          />

          {checkfromType !== "view" && (
            <button
              type="submit"
              className="px-4 py-2 rounded border-0 text-white submitbtn mb-2"
              disabled={checkfromType === "view"}
            >
              {isLoading && <i className="fa fa-spinner fa-spin me-2"></i>}
              {checkfromType === "add"
                ? t("Add")
                : checkfromType === "edit"
                  ? t("Update")
                  : ""}{" "}
              {t("Staff")}
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default Addstaff;
